import React from "react";
import JsonData from "../../data/data.json";

export const Privacy = ({ companyName, productName, contact, email }) => {
  return (
    <div className="page-top">
      <header className="bg-primary text-white">
        <div className="container text-center">
          <h1>Privacy Policy</h1>
        </div>
      </header>

      <section id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <h3>Privacy Policy</h3>
              <br />
              <p>
                {companyName}&nbsp; built mobile applications as free, freemium,
                ad-supported app. This SERVICE is provided by {companyName}
                &nbsp; and is intended for use as is.
                <br />
                <br />
                This page is used to inform visitors regarding my policies with
                the collection, use, and disclosure of Personal Information if
                anyone decided to use my Service.
                <br />
                <br />
                If you choose to use my Service, then you agree to the
                collection and use of information in relation to this policy.
                The Personal Information that I collect is used for providing
                and improving the Service. I will not use or share your
                information with anyone except as described in this Privacy
                Policy.
                <br />
                <br />
                The terms used in this Privacy Policy have the same meanings as
                in our Terms and Conditions, which is accessible at Paige
                Software unless otherwise defined in this Privacy Policy.
              </p>
              <br />
              <h3>Information Collection and Use</h3>
              <br />
              <p>
                For a better experience, while using our Service, I may require
                you to provide us with certain personally identifiable
                information. The information that I request will be retained on
                your device and is not collected by me in any way
                <br />
                <br />
                The app does use third party services that may collect
                information used to identify you.
              </p>
              <br />
              <h3>Log Data</h3>
              <br />
              <p>
                I want to inform you that whenever you use my Service, in a case
                of an error in the app I collect data and information (through
                third party products) on your phone called Log Data. This Log
                Data may include information such as your device Internet
                Protocol (“IP”) address, device name, operating system version,
                the configuration of the app when utilizing my Service, the time
                and date of your use of the Service, and other statistics.
              </p>
              <br />
              <h3>Cookies</h3>
              <br />
              <p>
                Cookies are files with a small amount of data that are commonly
                used as anonymous unique identifiers. These are sent to your
                browser from the websites that you visit and are stored on your
                device's internal memory.
                <br />
                <br />
                This Service does not use these “cookies” explicitly. However,
                the app may use third party code and libraries that use
                “cookies” to collect information and improve their services. You
                have the option to either accept or refuse these cookies and
                know when a cookie is being sent to your device. If you choose
                to refuse our cookies, you may not be able to use some portions
                of this Service.
              </p>
              <br />
              <h3>Service Providers</h3>
              <br />
              <p>
                I may employ third-party companies and individuals due to the
                following reasons:
              </p>
              <ul>
                <li>To facilitate our Service;</li>
                <li>To provide the Service on our behalf;</li>
                <li>To perform Service-related services; or</li>
                <li>To assist us in analyzing how our Service is used.</li>
              </ul>
              <p>
                I want to inform users of this Service that these third parties
                have access to your Personal Information. The reason is to
                perform the tasks assigned to them on my behalf. However, they
                are obligated not to disclose or use the information for any
                other purpose.
              </p>
              <br />
              <h3>Security</h3>
              <br />
              <p>
                I value your trust in providing us your Personal Information,
                thus we are striving to use commercially acceptable means of
                protecting it. But remember that no method of transmission over
                the internet, or method of electronic storage is 100% secure and
                reliable, and I cannot guarantee its absolute security.
              </p>
              <br />
              <h3>Links to Other Sites</h3>
              <br />
              <p>
                This Service may contain links to other sites. If you click on a
                third-party link, you will be directed to that site. Note that
                these external sites are not operated by me. Therefore, I
                strongly advise you to review the Privacy Policy of these
                websites. I have no control over and assume no responsibility
                for the content, privacy policies, or practices of any
                third-party sites or services.
              </p>
              <br />
              <h3>Changes to This Privacy Policy</h3>
              <br />
              <p>
                I may update our Privacy Policy from time to time. Thus, you are
                advised to review this page periodically for any changes. I will
                notify you of any changes by posting the new Privacy Policy on
                this page. This policy is effective as of 2020-06-29
              </p>
              <br />
              <h3>Contact Me</h3>
              <br />
              <p>
                If you have any questions or suggestions about my Privacy
                Policy, do not hesitate to contact me at {contact} or email me
                at {email}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const defaultProps = JsonData.Privacy;

Privacy.defaultProps = defaultProps;
